<script setup lang="ts">
    import { computed, onMounted, type Ref } from 'vue'
    import { useRoute } from 'vue-router'

    import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue'

    import { usePortfolioPlanningModuleStatusQueryV1 } from '@Quest/Portfolios/queries-vue-composables'

    import type { PortfolioPlanningModuleStatusReadModel } from '@Quest/Portfolios/readmodels'

    // ======================
    // Route
    // ======================

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const tchProjectId = computed(() => Number(route.params.tchProjectId ?? 0))

    // ======================
    // Query
    // ======================

    const {
        runPortfolioPlanningModuleStatusQueryV1,
        modelPortfolioPlanningModuleStatusQueryV1
    } = usePortfolioPlanningModuleStatusQueryV1(workspaceId, tchProjectId)

    const rm = modelPortfolioPlanningModuleStatusQueryV1 as Ref<PortfolioPlanningModuleStatusReadModel | null>

    // ======================
    // Lifecycle
    // ======================

    onMounted(() =>
    {
        document.title = "Portfolio planning | TransparentChoice"
        runPortfolioPlanningModuleStatusQueryV1()
    })
</script>

<template>
    <div>

        <PortfolioNavigation :workspaceId="workspaceId" :projectId="tchProjectId" />

        <div v-if="rm" class="container" style="margin-top: 80px; padding-top: 40px;">
            <div class="row">
                <div class="col-lg-6">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b; margin: 0;">Portfolio Planning - Beta Version</h1>
                </div>
                <div class="col-lg-6 text-right align-self-end">
                </div>
            </div>

            <hr style="border-color: #bbb; margin: 20px 0 60px;" />

            <div v-if="rm">

                <p>
                    Please note that the Portfolio Planning feature is currently in its beta phase and is not enabled on this portfolio.
                    We are actively working on refining this tool to ensure it meets our high standards of performance and user experience.
                </p>

                <p>
                    If you're interested in exploring the Portfolio Planning feature and would like to request beta access, we encourage you to contact us.
                    We value your interest and are eager to involve our users in the development process. By contacting us, you can gain early access and provide valuable feedback to help shape this feature.
                    We are more than happy to provide detailed information and updates, and we look forward to hearing from you.
                </p>

                <p>Thank you for your understanding and support as we continue to enhance our services.</p>
            </div>



        </div>

    </div>
</template>


